/* eslint-disable max-len */
/* eslint max-statements: 0 */
import React from 'react';
import { THREE } from '../../utilities/constants';
// import { DropdownList } from '../LanguageDropdown/DropdownMenu';
import styles from '../StepperBuilder/style.module.css';
import { svgList } from '../UserActivation-Contained/ConstantField';
import { BrandLogo } from '../../components/BrandLogo';

const STEP_NUMBER_PATHS = [
  'M15.333 19H13.7266V12.5469C13.7266 11.7767 13.7448 11.166 13.7812 10.7148C13.6764 10.8242 13.5465 10.945 13.3916 11.0771C13.2412 11.2093 12.7308 11.6286 11.8604 12.335L11.0537 11.3164L13.9932 9.00586H15.333V19Z',
  'M17.3906 19H10.6162V17.7832L13.1934 15.1924C13.9544 14.4131 14.458 13.8617 14.7041 13.5381C14.9548 13.21 15.137 12.9023 15.251 12.6152C15.3649 12.3281 15.4219 12.0205 15.4219 11.6924C15.4219 11.2412 15.2852 10.8857 15.0117 10.626C14.7428 10.3662 14.3691 10.2363 13.8906 10.2363C13.5078 10.2363 13.1364 10.307 12.7764 10.4482C12.4209 10.5895 12.0085 10.8447 11.5391 11.2139L10.6709 10.1543C11.2269 9.6849 11.7669 9.35221 12.291 9.15625C12.8151 8.96029 13.3734 8.8623 13.9658 8.8623C14.8955 8.8623 15.6406 9.10612 16.2012 9.59375C16.7617 10.0768 17.042 10.7285 17.042 11.5488C17.042 12 16.96 12.4284 16.7959 12.834C16.6364 13.2396 16.388 13.6589 16.0508 14.0918C15.7181 14.5202 15.1621 15.1012 14.3828 15.835L12.6465 17.5166V17.585H17.3906V19Z',
  'M17.0146 11.3027C17.0146 11.9362 16.8301 12.4648 16.4609 12.8887C16.0918 13.3079 15.5723 13.5905 14.9023 13.7363V13.791C15.7044 13.8913 16.306 14.1419 16.707 14.543C17.1081 14.9395 17.3086 15.4681 17.3086 16.1289C17.3086 17.0905 16.9691 17.8333 16.29 18.3574C15.611 18.877 14.6449 19.1367 13.3916 19.1367C12.2842 19.1367 11.3499 18.9567 10.5889 18.5967V17.168C11.0127 17.3776 11.4616 17.5394 11.9355 17.6533C12.4095 17.7673 12.8652 17.8242 13.3027 17.8242C14.0775 17.8242 14.6562 17.6807 15.0391 17.3936C15.4219 17.1064 15.6133 16.6621 15.6133 16.0605C15.6133 15.5273 15.4014 15.1354 14.9775 14.8848C14.5537 14.6341 13.8883 14.5088 12.9814 14.5088H12.1133V13.2031H12.9951C14.5902 13.2031 15.3877 12.6517 15.3877 11.5488C15.3877 11.1204 15.2487 10.79 14.9707 10.5576C14.6927 10.3252 14.2826 10.209 13.7402 10.209C13.362 10.209 12.9974 10.2637 12.6465 10.373C12.2956 10.4779 11.8809 10.6852 11.4023 10.9951L10.6162 9.87402C11.5322 9.19954 12.5964 8.8623 13.8086 8.8623C14.8158 8.8623 15.6019 9.07878 16.167 9.51172C16.7321 9.94466 17.0146 10.5417 17.0146 11.3027Z',
  'M17.7461 16.8193H16.3994V19H14.834V16.8193H10.2676V15.582L14.834 8.97852H16.3994V15.4863H17.7461V16.8193ZM14.834 15.4863V12.9775C14.834 12.0843 14.8568 11.3529 14.9023 10.7832H14.8477C14.7201 11.084 14.5195 11.4486 14.2461 11.877L11.7646 15.4863H14.834Z'
];

const COMPLETED_CHECKMARK_PATH =
  'M11.9999 16.7813L19.0626 9.71863L19.9999 10.656L11.9999 18.6566L8.28125 14.9373L9.21858 14L11.9999 16.7813Z';

export function Stepper (props) {
  const activeStep = props.activeStep;
  const getSVG = (arg) => {
    if (arg < activeStep) {
      return (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label={`Step ${arg + 1} completed`}>
          <circle cx="14" cy="14" r="12" className={styles.completedStepCircle} />
          <path d={COMPLETED_CHECKMARK_PATH} fill="white" />
        </svg>
      );
    }
    const path = STEP_NUMBER_PATHS[arg];
    if (activeStep === arg) {
      return (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label={`Step ${arg + 1} active`}>
          <circle cx="14" cy="14" r="12" className={styles.activeStepCircle} />
          {path ? <path d={path} fill="white" /> : null}
        </svg>
      );
    }
    return (
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label={`Step ${arg + 1} inactive`}>
        <circle cx="14" cy="14" r="12" className={styles.inactiveStepCircle} />
        {path ? <path d={path} fill="white" /> : null}
      </svg>
    );
  };

  const getSteps = () => {
    return svgList.map((h, index) => (
      <li key={index} className={h['step'] < activeStep ? styles.completed : styles.notcompleted}>
        {getSVG(h['step'])}{' '}
      </li>));
  };
  return (
    <>
      <div className={styles.centerIcon}>
        <BrandLogo className={styles.img} />
      </div>
      {/* {activeStep > ZERO ? <DropdownList /> : null} */}
      {activeStep <= THREE ? (
        <div className={styles.steps}>
          <ul aria-label={styles.stepsCount}>
            {getSteps()}
          </ul>
        </div>
      ) : null}
    </>
  );
}

export default Stepper;
